import Paragraph from './Paragraph'

export default Paragraph



// WEBPACK FOOTER //
// ./src/components/Paragraph/index.js